/* Scroll-in for [data-aos] elements (adds aos-animate when visible), as on the live theme. */
(function () {
  if (window.elAos) return;
  window.elAos = true;
  const run = () => {
    const els = document.querySelectorAll('[data-aos]:not(.aos-animate)');
    if (!('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('aos-animate')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('aos-animate'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -40px 0px' });
    els.forEach((el) => io.observe(el));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
